<app-hero [title]="'Artikeldetails'"></app-hero>
<div class="container">
  <div class="row">
    <div class="col-lg-8">
      <!-- Blog Details Section -->
      <section id="blog-details" class="blog-details section">
        <div class="container">
          <article class="article" *ngIf="article; else loading">
            <div class="post-img">
              <img *ngIf="article.coverUrl" [src]="article.coverUrl" alt="{{ article.title }}" class="img-fluid">
            </div>

            <h2 class="title">{{ article.title }}</h2>

            <div class="meta-top">
              <ul>
                <li class="d-flex align-items-center"><i class="bi bi-person"></i> {{ article.authorName || 'Unbekannt' }}</li>
                <li class="d-flex align-items-center"><i class="bi bi-clock"></i> <time [attr.datetime]="article.publishedAt?.toDate() | date:'yyyy-MM-dd'">{{ article.publishedAt?.toDate() | date:'d. MMMM yyyy' }}</time></li>
                <li class="d-flex align-items-center"><i class="bi bi-chat-dots"></i> {{ comments.length }} Kommentare</li>
                <li class="d-flex align-items-center"><i class="bi bi-eye"></i> {{ article.views || 0 }} Aufrufe</li>
              </ul>
            </div><!-- End meta top -->

            <div class="content" [innerHTML]="article.content"></div><!-- End post content -->

            <div class="meta-bottom">
              <i class="bi bi-folder"></i>
              <ul class="cats">
                <li>{{ article.category || 'Ohne Kategorie' }}</li>
              </ul>
            </div><!-- End meta bottom -->
          </article>

          <ng-template #loading>
            <div *ngIf="showSpinner" class="text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Lädt...</span>
              </div>
            </div>
            <div *ngIf="!showSpinner" class="text-center text-muted">
              Artikel nicht gefunden
            </div>
          </ng-template>
        </div>
      </section><!-- /Blog Details Section -->

      <!-- Blog Comments Section -->
      <section id="blog-comments" class="blog-comments section">
        <div class="container">
          <h4 class="comments-count">{{ comments.length }} Kommentare</h4>

          <div *ngFor="let comment of comments; let i = index" id="comment{{ i + 1 }}" class="comment">
            <div class="d-flex">
              <div class="comment-img"><img [src]="comment.image" alt="Benutzerbild"></div>
              <div>
                <h5><a>{{ comment.name }}</a>
                  <a *ngIf="isAdmin || userUid==comment.userId" (click)="deleteComment(article!.id, comment.id)" class="reply ms-2 text-danger"><i class="bi bi-trash"></i> Löschen</a>
                  <a (click)="toggleReplyForm(comment.id)" class="reply"><i class="bi bi-reply-fill"></i> Antworten</a></h5>
                <time [attr.datetime]="comment.createdAt?.toDate() | date:'yyyy-MM-dd'">{{ comment.createdAt?.toDate() | date:'d. MMMM yyyy' }}</time>
                <p>{{ comment.comment }}</p>
              </div>
            </div>

            <!-- Reply Form -->
            <form *ngIf="showReplyForm[comment.id]" #replyForm="ngForm" (ngSubmit)="addReply(comment.id, replyForm)" class="reply-form">
              <div class="row mb-2">
                <div class="col form-group">
                  <textarea name="reply" class="form-control" placeholder="Ihre Antwort*" [(ngModel)]="newReply.reply" required></textarea>
                </div>
              </div>
              <button type="submit" class="btn btn-primary" [disabled]="replyForm.invalid">Antwort veröffentlichen</button>
              <button type="button" class="btn btn-secondary ms-2" (click)="toggleReplyForm(comment.id)">Abbrechen</button>
            </form>

            <!-- Replies -->
            <div *ngFor="let reply of comment.replies" class="reply replay-section">
              <div class="d-flex">
                <div class="comment-img"><img [src]="reply.image" alt="Benutzerbild"></div>
                <div>
                  <h5><a>{{ reply.name }}</a>
                    <a *ngIf="isAdmin || userUid==reply.userId" (click)="deleteReply(article!.id, comment.id, reply.id)" class="reply ms-2 text-danger"><i class="bi bi-trash"></i> Löschen</a></h5>
                  <time [attr.datetime]="reply.createdAt?.toDate() | date:'yyyy-MM-dd'">{{ reply.createdAt?.toDate() | date:'d. MMMM yyyy' }}</time>
                  <p>{{ reply.reply }}</p>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="comments.length === 0" class="text-muted">
            Noch keine Kommentare.
          </div>
        </div>
      </section><!-- /Blog Comments Section -->

      <!-- Comment Form Section -->
      <section id="comment-form" class="comment-form section">
        <div class="container">
          <form #commentForm="ngForm" (ngSubmit)="addComment(commentForm)">
            <h4>Kommentar veröffentlichen</h4>
            <div class="row">
              <div class="col form-group">
                <textarea name="comment" class="form-control" placeholder="Ihr Kommentar*" [(ngModel)]="newComment.comment" required></textarea>
              </div>
            </div>
            <div>
              <button type="submit" class="btn btn-primary" [disabled]="commentForm.invalid">Kommentar veröffentlichen</button>
            </div>
          </form>
        </div>
      </section><!-- /Comment Form Section -->
    </div>

    <div class="col-lg-4 sidebar">
      <div class="widgets-container">
        <!-- Search Widget -->
        <div class="search-widget widget-item">
          <h3 class="widget-title">Suche</h3>
          <form #searchForm="ngForm" (ngSubmit)="performSearch(searchQuery)">
            <div class="search-container">
              <input
                type="text"
                name="query"
                [(ngModel)]="searchQuery"
                (ngModelChange)="onSearchInput($event)"
                placeholder="Artikel suchen..."
                required
                class="form-control"
              >
              <button type="submit" title="Suche" [disabled]="searchForm.invalid">
                <i class="bi bi-search"></i>
              </button>
              <ul class="search-dropdown" *ngIf="showSearchDropdown && searchResults.length > 0">
                <li *ngFor="let result of searchResults" (click)="selectSearchResult(result.id)">
                  <div class="search-result-item">
                    <img *ngIf="result.coverUrl" [src]="result.coverUrl" alt="{{ result.title }}" class="search-result-img">
                    <div>
                      <h4>{{ result.title }}</h4>
                      <time [attr.datetime]="result.publishedAt?.toDate() | date:'yyyy-MM-dd'">
                        {{ result.publishedAt?.toDate() | date:'d. MMMM yyyy' }}
                      </time>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </form>
        </div><!--/Search Widget -->

        <!-- Categories Widget -->
        <div class="categories-widget widget-item">
          <h3 class="widget-title">Kategorien</h3>
          <ul class="mt-3">
            <li *ngFor="let cat of categories"><a href="#">{{ cat.name }} <span>({{ cat.count }})</span></a></li>
          </ul>
        </div><!--/Categories Widget -->

        <!-- Recent Posts Widget -->
        <div class="recent-posts-widget widget-item">
          <h3 class="widget-title">Neueste Beiträge</h3>
          <div class="post-item" *ngFor="let recent of recentArticles" [routerLink]="['/Article', recent.id]" style="cursor: pointer;">
            <img *ngIf="recent.coverUrl" [src]="recent.coverUrl" alt="{{ recent.title }}" class="flex-shrink-0">
            <div>
              <h4><a [routerLink]="['/Article', recent.id]">{{ recent.title }}</a></h4>
              <time [attr.datetime]="recent.publishedAt?.toDate() | date:'yyyy-MM-dd'">{{ recent.publishedAt?.toDate() | date:'d. MMMM yyyy' }}</time>
            </div>
          </div>
        </div><!--/Recent Posts Widget -->
      </div>
    </div>
  </div>
</div>